<template>
  <base-card>
    <div v-if="user.profile.avatar" class="mb-4 text-center">
      <img :src="user.profile.avatar" alt="" class="img-thumbnail rounded-circle w-50">
    </div>

    <dl class="mb-0">
      <template v-if="user.profile.isCompany">
        <dt>Company</dt>
        <dd>{{ user.profile.companyName }}</dd>
      </template>
      <template v-else>
        <dt>Name</dt>
        <dd>{{ name }}</dd>
      </template>
      <dt>Email</dt>
      <dd>
        <template v-if="noLinkableAddress">
          {{ user.email }}
        </template>
        <template v-else>
          <a :href="`mailto:${user.email}`">{{ user.email }}</a>
        </template>
      </dd>
      <template v-if="!user.profile.isCompany">
        <dt>Date of Birth</dt>
        <dd>{{ $dates.toDate(user.profile.dob) }}</dd>
      </template>
      <dt>Telephone</dt>
      <dd>{{ user.profile.phone }}</dd>
      <dt v-if="$auth.admin()">Role</dt>
      <dd v-if="$auth.admin()">{{ user.role.name }}</dd>
      <dt>Address</dt>
      <dd>
        <formatted-address :address="user.profile.address" />
      </dd>
    </dl>

    <div class="mt-3 text-center">
      <router-link v-if="$auth.admin() && !showChangeButton()" :to="{ name: 'users.edit', params: { id: user._id } }">
        Edit
      </router-link>
      <router-link v-if="showChangeButton()" :to="{ name: 'preferences' }">
        Change these details
      </router-link>
    </div>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

import FormattedAddress from './FormattedAddress.vue'

export default {
  name: 'UserCard',

  components: {
    FormattedAddress
  },

  props: {
    noChangeButton: {
      default: false,
      Boolean
    },
    noLinkableAddress: {
      default: false,
      Boolean
    },
    user: {
      required: true,
      type: Object
    }
  },

  computed: {
    name () {
      const {
        firstName, lastName, company, isCompany
      } = this.user.profile

      if (isCompany) {
        return company
      }

      return `${firstName} ${lastName}`
    },

    ...mapState({
      auth: store => store.core.auth.user
    })
  },

  methods: {
    showChangeButton () {
      return this.user._id === this.auth._id && !this.noChangeButton
    }
  }
}
</script>
